const raw = import.meta.env.VITE_API_BASE_URL;
const extensionId = import.meta.env.VITE_EXTENSION_ID ?? '';

if (typeof raw !== 'string') {
  throw new Error('VITE_API_BASE_URL must be defined (set to "" for same-origin proxy)');
}

// 空文字 = same-origin proxy (Pages Functions /api/* → Workers)
// 値あり = 直接 Workers の URL を叩く (ローカル dev など)
export const env = { apiBaseUrl: raw, extensionId } as const;
